// import axios from "axios";

// // Create an Axios instance
// const axiosInstance = axios.create({
//   baseURL: "https://api-staging.wihan.in/",
//   // baseURL: "http://192.168.0.242:9876/",
// });

// axiosInstance.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     config.headers["Authorization"] = `Token ${token}`;
//   }
//   return config;
// });

import axios from "axios";
import { ENV, getDomainHeader } from "../env";

const axiosInstance = axios.create({
  baseURL: ENV.baseURL,
});

// Add a request interceptor to attach the token and domain
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }

  config.headers["Domain"] = getDomainHeader("");
  return config;
});

export default axiosInstance;

